import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import cssClasses from './cssClasses';

const SuggestPickerItem = (props) => {
    const { index, highlighted, children } = props;

    const handleMouseDown = (event) => {
        props.handleMouseDown(event, index);
    };

    const handleMouseMove = () => {
        const { handleMouseMove } = props;
        handleMouseMove && handleMouseMove(index);
    };

    const handleMouseEnter = () => {
        props.handleMouseEnter(index);
    };

    return (
        <li
            className={classNames(`suggest__item`, `suggest__item_delimiter_line`, {
                [cssClasses.state.highlighted]: highlighted,
            })}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseEnter={handleMouseEnter}
        >
            {children}
        </li>
    );
};

SuggestPickerItem.propTypes = {
    /** Индекс элемента списка */
    index: PropTypes.number.isRequired,
    /** Содержимое элемента списка */
    children: PropTypes.node.isRequired,
    /** Является ли элемент подсвеченным */
    highlighted: PropTypes.bool,
    /** Обработчики событий мыши */
    handleMouseEnter: PropTypes.func.isRequired,
    handleMouseMove: PropTypes.func,
    handleMouseDown: PropTypes.func.isRequired,
};

SuggestPickerItem.defaultProps = {
    highlighted: false,
};

export default SuggestPickerItem;
